import type {
	LWApiPublicAccountUserDetailsParamsRawI,
	LWApiPublicAccountUserDetailsResultRawI,
	LWApiPublicAccountUserListResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import {
	useQuery,
	useQueryClient,
	type UseQueryOptions,
} from '@tanstack/react-query';
import api from 'modules/queries/api';

import { mergeUsersFromListQueriesData } from './mergeUsersFromListQueriesData';
import { ACCOUNT_USER_LIST_QUERY_KEY } from './useList';

export const ACCOUNT_USER_DETAILS_QUERY_KEY = '/account/user/details';

const useAccountUserDetails = (
	params: LWApiPublicAccountUserDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicAccountUserDetailsResultRawI, ApiErrorI>,
) => {
	const queryClient = useQueryClient();

	return useQuery({
		queryKey: [ACCOUNT_USER_DETAILS_QUERY_KEY, params],
		queryFn: () => api.account.user.apiRaw.details(params),

		initialData: () => {
			const queries =
				queryClient.getQueriesData<LWApiPublicAccountUserListResultRawI>([
					ACCOUNT_USER_LIST_QUERY_KEY,
				]);
			const queriesData = queries.map(([_queryKey, queryData]) => queryData);
			return mergeUsersFromListQueriesData(queriesData, params.username);
		},

		...options,
	});
};

export default useAccountUserDetails;
